import { ClientType } from "@enums/client-type.enum";

export class Utils {

    public static isOfficeWindows(): boolean {
        
        return Office?.context?.platform === Office.PlatformType.PC || Office?.context?.platform == null;
    }

    public static isOfficeMac(): boolean {

        return Office?.context?.platform === Office.PlatformType.Mac;
    }

    public static isOfficeLocal(): boolean {
        
        return this.isOfficeWindows() || this.isOfficeMac();
    }

    public static isItemTypeAppointment(): boolean {

        return Office?.context?.mailbox?.item?.itemType === Office.MailboxEnums.ItemType.Appointment;
    }

    public static isNotItemTypeMessage(): boolean {

        return Office?.context?.mailbox?.item?.itemType !== Office.MailboxEnums.ItemType.Message;
    }

    public static getItemType(): string {

        return Office?.context?.mailbox?.item?.itemType || "unknown";
    }

    public static getClientType(): ClientType {

        switch (Office?.context?.platform) {
            case Office?.PlatformType?.PC:
            case null: {
                return ClientType.Windows;
            }
            case Office?.PlatformType?.Mac: {
                return ClientType.Mac;
            }
            case Office?.PlatformType?.OfficeOnline: {
                return ClientType.Web;
            }
            default: {
                return ClientType.Unknown;
            }
        }
    }

    public static getUnsecuredGuid(): string {

        // Do not use this method if the GUID is to be stored in a database as there 
        // might be conflicts since this does not guarantee good uniqueness.
        
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
    }

    public static getStringSizeBytes(str: string): number {
        // Assumes that all characters are UNICODE. The actual size could be higher.
        return str.length;
    }

    public static getSizeBytes(obj: any) {
        switch (typeof obj) {
            case 'string':
                return this.getStringSizeBytes(obj as string);

            default:
                throw Error("Object type not supported");
        }
    }

    public static getArraySizeBytes<Type>(data: Type[]): number {
        
        return data.reduce((prev, curr) => {
            return prev + this.getSizeBytes(curr);
        }, 0);
    }
}